/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type STORY_MODE = "COMMENTS" | "QA" | "RATINGS_AND_REVIEWS" | "%future added value";
export type UserTagsContainer_story = {
    readonly settings: {
        readonly mode: STORY_MODE;
    };
    readonly " $refType": "UserTagsContainer_story";
};
export type UserTagsContainer_story$data = UserTagsContainer_story;
export type UserTagsContainer_story$key = {
    readonly " $data"?: UserTagsContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"UserTagsContainer_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserTagsContainer_story",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "StorySettings",
            "kind": "LinkedField",
            "name": "settings",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mode",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = 'd8d0fc83c5b6bb0d8e1c7995b848cd9b';
export default node;
